(function () {

// Return a version of func that will only be run after it has stopped being
// called for a certain time.
function debounce(func) {
  var debounceDelay = 250;
  var debounceTimeout = null;

  function debouncedFunc() {
    window.clearTimeout(debounceTimeout);
    debounceTimeout = window.setTimeout(func, debounceDelay);
  }

  return debouncedFunc;
}


// Return a version of func that will be called only after a certain time has
// passed since it was last called.
function throttle(func) {
  var throttleDelay = 50;
  var enabled = true;

  function throttledFunc() {
    if (enabled) {
      func();
      enabled = false;
      window.setTimeout(function () {
        enabled = true;
      }, throttleDelay);
    }
  }

  return throttledFunc;
}


function setupChart(canvasEl, data, type) {
  // Take a context, return whether the value in question is relatively small,
  // and so has limited space for its label.
  function isSmallValue(context) {
    var index = context.dataIndex;
    var value = context.dataset.data[index];
    var max = context.dataset.data.reduce(function (a, b) {
      return Math.max(a, b);
    });
    return value < max / 5;
  }

  // For a pie chart, this works differently: a value is small in relation to
  // the sum of all values, not to the maximum value.
  function isSmallPieValue(context) {
    var index = context.dataIndex;
    var value = context.dataset.data[index];
    var total = context.dataset.data.reduce(function (a, b) {
      return a + b;
    });
    return value < total / 12;
  }

  // Options per chart type
  var options = {
    bar: {
      layout: {
        padding: { top: 24 }
      },
      scales: {
        yAxes: [
          {
            display: false,
            ticks: {
              beginAtZero: true
            }
          }
        ]
      },
      plugins: {
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: 'white'
        }
      }
    },
    horizontalBar: {
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            display: false,
            ticks: {
              beginAtZero: true
            }
          }
        ]
      },
      plugins: {
        datalabels: {
          anchor: 'end',
          align: function (context) {
            return isSmallValue(context) ? 'end' : 'start';
          },
          color: function (context) {
            return isSmallValue(context) ? 'white' : '#09233c';
          }
        }
      }
    },
    pie: {
      legend: {
        display: true,
        onClick: function () {}
      },
      tooltips: {
        callbacks: {
          label: function (tooltipItem, data) {
            var datasetIndex = tooltipItem.datasetIndex;
            var index = tooltipItem.index;
            var label = data.labels[index];
            var value = data.datasets[datasetIndex].data[index];
            return ' ' + label + ': ' + value + ' %';
          }
        }
      },
      plugins: {
        datalabels: {
          anchor: 'center',
          align: 'center',
          display: function (context) { return !isSmallPieValue(context) }
        }
      }
    }
  };

  var ctx = canvasEl.getContext('2d');

  // Set dataset background colors according to chart type
  var datasets = [
    {
      data: data.values,
    }
  ];

  if (type == 'pie') {
    datasets[0].backgroundColor = ['#f86e15', '#ffc700', '#77d4a6', '#00c9f6', 'white', '#004f90'];
  }
  else {
    datasets[0].backgroundColor = '#00caf4';
  }

  var chart = new Chart(ctx, {
    type: type,
    data: {
      labels: data.keys,
      datasets: datasets
    },
    options: options[type]
  });

  if (data.extra_keys && data.extra_values) {
    (function () {
      var expanded = false;
      var containerEl = canvasEl.parentNode.parentNode;
      var linkEl = document.createElement('a');
      linkEl.setAttribute('href', '#');
      linkEl.classList.add('chart__expand');
      linkEl.innerText = 'Show more';
      containerEl.appendChild(linkEl);

      linkEl.addEventListener('click', function (event) {
        event.preventDefault();
        if (expanded) {
          chart.data.datasets[0].data = data.values;
          chart.data.labels = data.keys;
          linkEl.innerText = 'Show more';
        }
        else {
          chart.data.datasets[0].data = data.values.concat(data.extra_values);
          chart.data.labels = data.keys.concat(data.extra_keys);
          linkEl.innerText = 'Show less';
        }
        linkEl.classList.toggle('chart__expand--active');
        expanded = !expanded;
        chart.update();
      });
    })();
  }
};


function setupCharts() {
  var charts = document.querySelectorAll("[data-chart-id]");
  var element;
  var data;
  var type;
  var i;

  Chart.plugins.register(ChartDataLabels);

  Chart.defaults.global.maintainAspectRatio = false;
  Chart.defaults.global.defaultFontColor = 'white';
  Chart.defaults.global.defaultFontSize = 14;
  Chart.defaults.global.legend.display = false;
  Chart.defaults.global.tooltips.callbacks.label = function (tooltipItem, data) {
    return ' ' + tooltipItem.value + ' %';
  };
  Chart.defaults.scale.gridLines.display = false;

  // The data labels plugin shows values on top of the chart
  Chart.defaults.global.plugins.datalabels.color = '#09233c';
  Chart.defaults.global.plugins.datalabels.formatter = function (value) {
    return value + ' %';
  };

  for (i = 0; i < charts.length; i++) {
    element = charts[i];
    data = FN.surveyData[element.dataset.chartId];
    type = element.dataset.chartType;
    setupChart(element.querySelector('canvas'), data, type);
  }
};


function setupQuoteShareButtons() {
  function setupCallout(el) {
    var shareText = el.getAttribute('data-sharetext');

    var facebook = el.querySelector('.callout__button--facebook');
    var twitter = el.querySelector('.callout__button--twitter');
    var linkedin = el.querySelector('.callout__button--linkedin');

    facebook.addEventListener('click', function (event) {
      event.preventDefault();
      FN.socialShare('facebook', null, shareText);
    });

    twitter.addEventListener('click', function (event) {
      event.preventDefault();
      FN.socialShare('twitter', null, shareText);
    });

    linkedin.addEventListener('click', function (event) {
      event.preventDefault();
      FN.socialShare('linkedin', null, shareText);
    });
  }


  var shareCallouts = document.querySelectorAll('.callout__buttons');
  var i;

  for (i = 0; i < shareCallouts.length; i++) {
    setupCallout(shareCallouts[i]);
  }
}


// Adapted from default.js
function setupNavToggle() {
  var toggleEl = document.getElementById('nav-toggle');
  var claimEl = document.getElementById('tower-claim');
  var navEl = document.querySelector('nav ul');
  var navVisible = false;

  toggleEl.addEventListener('click', function (event) {
    navVisible = !navVisible;

    if (navVisible) {
      claimEl.style.display = 'none';  
      navEl.style.display = 'table-cell';
    }
    else {
      claimEl.style.display = 'block';
      navEl.style.display = 'none';
    }
  });
}


function setupNewsletter() {
  // Prefill 'source[OS]' value
  if ($('input[name="signup[OS]"]').length > 0) {
    $('input[name="signup[OS]"]').val(FN.helpers.platform());
  }

  $('.' + FN.newsletterConfig.selectors.formClass).each(function (_, element) {
    FN.newsletterConfig.instances.push(new FN.newsletter(element));
  });
}


$(document).ready(function () {
  $.scrollIt();

  setupCharts();

  setupQuoteShareButtons();

  setupNavToggle();

  setupNewsletter();
});

})();
